<template>
  <ui-content title="Agencia Reporte">
    <ui-card v-if="loading.view == false">
      <ValidationObserver ref="form">
        <div class="row form-row align-items-center mb-2">
          <div class="col-lg-3">
            <label for="" class="form-label">Agencia:</label>
            <InputSelect v-model="form.agencia" :options="containers.agencias" :rules="'required'" :name="'Agencia'" :vid="'agencia'" label="nombre"></InputSelect>
          </div>
          <div class="col-lg-3">
            <label for="" class="form-label">Servicio:</label>
            <InputSelect v-model="form.servicio" :options="containers.servicios" :name="'Servicio'" :vid="'servicio'" label="nombre"></InputSelect>
          </div>
          <div class="col-lg-3">
            <label for="" class="form-label">Fecha Inicio:</label>
            <InputDatepicker v-model="form.fecha_inicio" rules="required" name="Fecha Inicio" input-class="form-control form-control-sm"></InputDatepicker>
          </div>
          <div class="col-lg-3">
            <label for="" class="form-label">Fecha Fin:</label>
            <InputDatepicker v-model="form.fecha_fin" rules="required" name="Fecha Fin" input-class="form-control form-control-sm"></InputDatepicker>
          </div>
        </div>
      </ValidationObserver>
      <div class="form-group">
        <button class="btn btn-primary" @click="onSearch" :disabled="loading.search">
          Buscar
        </button>
        <button v-if="reportes.length" class="btn btn-outline-secondary ml-2" @click="onPrint">
          Imprimir
        </button>
      </div>
      <hr />
      <EndosadosTable v-if="reportes && reportes.length" :rows="reportes" :actions="false" :pagination="false"></EndosadosTable>
    </ui-card>
  </ui-content>
</template>
<script>
import EndosadosTable from "../../endosados/components/EndosadosTable.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import { BTableLite } from "bootstrap-vue";
import DatePicker from "vue2-datepicker";
import pdfEndosados from "../../../pdfs/pdfEndosados";

export default {
  components: {
    DatePicker,
    BTableLite,
    InputSelect,
    InputDatepicker,
    EndosadosTable,
  },
  data() {
    return {
      form: {
        agencia: "",
        servicio: "",
        fecha_inicio: "",
        fecha_fin: "",
      },
      reportes: [],
      containers: {
        servicios: [],
        agencias: [],
      },
      loading: {
        view: true,
        search: false,
      },
    };
  },
  async created() {
    const vm = this;

    try {
      let response = await vm.axios.get("/agencias");
      vm.containers.agencias = response.data.content;

      response = await vm.axios.get("/servicios");
      vm.containers.servicios = response.data.content;

      vm.loading.view = false;
    } catch (error) {
      console.log({ error });
    }
  },
  computed: {
    usuarios() {
      const vm = this;
      let usuarios = vm.reportes.map((item) => item.usuarioCreador);
      usuarios = [...new Set(usuarios)];
      return usuarios;
    },
    agencia() {
      if (!this.form.agencia) return "";
      return this.containers.agencias.find((item) => item.idAgencia == this.form.agencia)?.nombre || "";
    },
  },
  methods: {
    async onSearch() {
      const vm = this;

      const validated = await vm.$refs.form.validate();
      if (!validated) {
        vm.$toast.fire({ title: "Completa los campos requeridos", icon: "warning" });
        return;
      }

      if (vm.$dayjs(vm.form.fecha_inicio) > vm.$dayjs(vm.form.fecha_fin)) {
        return vm.$toast.fire("Fecha inicio no puede ser mayor a fecha fin", "", "warning");
      }

      vm.reportes = [];
      vm.loading.search = true;

      vm.axios
        .post(`/reportes/endosados`, {
          idAgencia: vm.form.agencia.idAgencia,
          idServicio: vm.form.servicio?.idServicio || null,
          fechaInicio: vm.form.fecha_inicio,
          fechaFin: vm.form.fecha_fin,
        })
        .then((response) => {
          vm.reportes = response.data.content.map((row) => {
            let observacionesExtras = [];

            if (row.horaTicket) {
              observacionesExtras.push(`<strong>HT</strong>: ${this.$options.filters.date(row.horaTicket, "HH:mm:ss", "HH:mm")}`);
            }
            if (row.horaHuayna) {
              observacionesExtras.push(`<strong>HHP</strong>: ${this.$options.filters.date(row.horaHuayna, "HH:mm:ss", "HH:mm")}`);
            }
            if (row.hotelOvernight) {
              observacionesExtras.push(`<strong>ON</strong>: ${row.hotelOvernight}`);
            }
            if (row.restaurante) {
              observacionesExtras.push(`<strong>L</strong>: ${row.restaurante}`);
            }
            if (row.idOrigen) {
              observacionesExtras.push(`<strong>OR</strong>: ${row.origen}`);
            }
            if (row.idDestino) {
              observacionesExtras.push(`<strong>DE</strong>: ${row.destino}`);
            }

            observacionesExtras = observacionesExtras.join(" / ");

            return {
              ...row,
              trenInOut: {
                in: String(row.trenIn || "").trim(),
                out: String(row.trenOut || "").trim(),
              },
              horaRecojoInicio: {
                recojo: String(row.horaRecojo || "").trim(),
                inicio: String(row.horaInicio || "").trim(),
              },
              vehiculoConductor: {
                vehiculo: String(row.vehiculo || "").trim(),
                otroVehiculo: String(row.otroVehiculo || "").trim(),
                conductor: String(row.conductor || "").trim(),
                otroConductor: String(row.otroConductor || "").trim(),
              },
              observacionesExtras: observacionesExtras.length ? observacionesExtras : null,
            };
          });
        })
        .finally(() => {
          vm.loading.search = false;
        });
    },
    onPrint() {
      const endoses = this.reportes.map((item) => ({
        ...item,
        horaInicio: item.horaInicio ? this.$dayjs(item.horaInicio, "HH:mm:ss").format("HH:mm") : "",
        horaRecojo: item.horaRecojo ? this.$dayjs(item.horaRecojo, "HH:mm:ss").format("HH:mm") : "",
        horaHuayna: item.horaHuayna ? this.$dayjs(item.horaHuayna, "HH:mm:ss").format("HH:mm") : "",
        horaTicket: item.horaTicket ? this.$dayjs(item.horaTicket, "HH:mm:ss").format("HH:mm") : "",
        fecha: item.fecha ? this.$dayjs(item.fecha).format("DD-MM-YY") : "",
        vehiculo: item.vehiculo || item.otroVehiculo || "",
        conductor: item.conductor || item.otroConductor || "",
      }));

      pdfEndosados({
        endoses,
        servicio: this.form.servicio?.nombre || "",
        fechaInicio: this.form.fecha_inicio ? this.$dayjs(this.form.fecha_inicio).format("DD-MM-YY") : "",
        fechaFin: this.form.fecha_fin ? this.$dayjs(this.form.fecha_fin).format("DD-MM-YY") : "",
        agencia: this.form.agencia?.nombre || "",
        pasajero: "",
        reporte: true,
        userMark: this.$store.state.user,
        dateMark: this.$dayjs().format("DD-MM-YY HH:mm"),
      });
    },
  },
};
</script>
